<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row>
        <v-col cols="12">
          <h1 class="primary--text font-weight-medium">
            {{ $t('transfer_internal_account') }}
          </h1>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            :name="$t('transfer_alias')"
            rules="required|max:200"
            v-slot="{ errors }"
          >
            <v-text-field
              :label="`${$t('transfer_alias')} *`"
              dense
              autocomplete="nope"
              v-model="permanentInstruction.alias"
              :error-messages="errors[0]"
              hide-details="auto"
              maxlength="200"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <ValidationProvider
            :name="$t('transfer_account_code')"
            rules="required|max:50"
            v-slot="{ errors }"
          >
            <v-text-field
              :label="`${$t('transfer_account_code')} *`"
              dense
              autocomplete="nope"
              v-model="permanentInstruction.bnfBankAccNumber"
              :error-messages="errors[0]"
              hide-details="auto"
              maxlength="50"
            />
          </ValidationProvider>
        </v-col>
        <v-col
          v-if="showBeneficiariesSelect"
          cols="12"
          md="6"
          class="d-flex flex-grow-1"
        >
          <ValidationProvider
            :name="$t('transfer_name')"
            rules="required|max:150"
            v-slot="{ errors }"
            class="flex-grow-1"
          >
            <v-select
              :label="`${$t('transfer_name')} *`"
              v-model="permanentInstruction.beneficiary"
              :items="beneficiaries"
              dense
              autocomplete="nope"
              :error-messages="errors[0]"
              hide-details="auto"
            />
          </ValidationProvider>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn
                v-if="lockedField"
                icon
                v-on="on"
                @click="handleUnlock"
                :disabled="!lockedField"
              >
                <v-icon>mdi-lock-open-variant</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('modify_beneficiary') }}</span>
          </v-tooltip>
        </v-col>
        <v-col v-else :cols="12" :md="6" class="d-flex flex-grow-1">
          <ValidationProvider
            class="flex-grow-1"
            :name="$t('transfer_name')"
            rules="required|max:200"
            v-slot="{ errors }"
          >
            <v-text-field
              class="flex-grow-1"
              ref="beneficiary"
              :label="`${$t('transfer_name')} *`"
              dense
              autocomplete="nope"
              v-model="permanentInstruction.beneficiary"
              :error-messages="errors[0]"
              :disabled="lockedField"
              hide-details="auto"
              maxlength="200"
            />
          </ValidationProvider>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn
                v-if="lockedField"
                icon
                v-on="on"
                @click="handleUnlock"
                :disabled="!lockedField"
              >
                <v-icon>mdi-lock-open-variant</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('modify_beneficiary') }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12">
          <v-text-field
            :label="$t('transfer_observations')"
            dense
            autocomplete="nope"
            v-model="permanentInstruction.bnfReference"
            maxlength="128"
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            :label="$t('transfer_instructions')"
            dense
            autocomplete="nope"
            v-model="permanentInstruction.avsInternalRemark"
            maxlength="128"
            hide-details="auto"
          />
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
import { mapState } from 'vuex'
export default {
  components: {
    WizardForm
  },
  props: {
    permanentInstruction: {
      type: [Object]
    }
  },
  data() {
    return {
      lockedField: true,
      showBeneficiariesSelect: true,
      stepTwo: {
        account_type: 'Cuentas de Bancos en Panamá'
      },
      items: [
        'Cuenta Corriente en Banco',
        'Cuenta Ahorro en Banco',
        'Cuenta Inversión en Institución Financiera no Banco'
      ],
      banks: ['Banco Mercantil', 'Banesco'],
      isThirdParty: false
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('account', ['account', 'accountData']),
    isExecutive() {
      return (
        this.user?.authorityLevelsCode === 1 ||
        this.user?.authorityLevelsCode === 2 ||
        this.user?.authorityLevelsCode === 4
      )
    },
    isAccountCode() {
      return (
        this.user?.avobjects?.findIndex(
          item =>
            item.code === this.account.code && item.typeCode === 'accountCode'
        ) > -1
      )
    },
    beneficiaries() {
      let items = []
      const main = this.accountData.firstname + ' ' + this.accountData.lastname
      items.push(main)

      if (this.accountData.type.toUpperCase() === 'JURIDICA') {
        const beneficiaries = this.accountData.beneficiaries
          .map(item => item.firstname + ' ' + item.lastname)
          .filter(item => item.trim() !== '')

        items = items.concat(beneficiaries)
      } else if (
        this.accountData.coOwners &&
        this.accountData.coOwners.trim() !== ''
      ) {
        items.push(this.accountData.coOwners)
      }

      return items
    }
  },
  methods: {
    async handleUnlock() {
      const text = !this.isExecutive
        ? this.$t('warning_instructions_payments_to_third_parties_customer')
        : this.$t('warning_instructions_payments_to_third_parties_1') +
          ' ' +
          this.$t('warning_instructions_payments_to_third_parties_2')

      const params = {
        text,
        title: this.$t('twofactor_modal_warning_title'),
        showClose: false,
        persistent: true,
        actions: {
          true: {
            text: this.$t('btn_accept'),
            color: 'primary'
          }
        }
      }

      await this.$dialog.info(params)

      if (this.isExecutive) {
        this.isThirdParty = true
        this.lockedField = false
        this.showBeneficiariesSelect = false
        this.permanentInstruction.beneficiary = ''
        this.permanentInstruction.bnfEmail = ''
        this.permanentInstruction.bnfEmailConfirm = ''
        this.permanentInstruction.isThirdParty = this.isThirdParty

        // Set focus
        this.$nextTick(() => this.$refs.beneficiary.focus())
      }
    }
  }
}
</script>
<style scoped>
.main-container {
  line-height: normal;
}

hr {
  margin: 0;
  padding: 0;
}

hr.rounded {
  border-top: 2px solid;
  width: 400px;
}
</style>
